<template>
  <div class="contractAdmin">
    <el-dialog
      title="合同管理"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1200px"
      :before-close="close"
    >
      <div v-if="(!checkAdmin() && type) || !type" class="title">
        <el-button
          size="small"
          type="primary"
          @click="openHandleContract('add')"
        >添加合同</el-button>
      </div>
      <el-table border v-loading="loading" :data="data" style="width: 100%">
        <el-table-column label="合同名称" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.name || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="type" label="合同审核状态" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.auditState === 0">待审核</span>
            <span v-if="row.auditState === 1">已通过</span>
            <span v-if="row.auditState === 2">已驳回</span>
          </template>
        </el-table-column>
        <el-table-column label="合同生效日期" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.contractValidityStart || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="合同截止日期" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.contractValidityEnd || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column width="230" fixed="right" align="center" label="操作">
          <template slot-scope="{ row }">
            <span v-if="type" :class="['blue_Box', row.hasReject === 0 && 'is-disabled']" @click="rejectedList(row)">驳回原因</span>
            <span class="blue_Box" v-if="row.fileurl" @click="lookFile(row)">查看附件</span>
            <span v-if="(!checkAdmin() && type) || !type" class="blue_Box" @click="openHandleContract('alter', row)">编辑</span>
            <span v-if="(!checkAdmin() && type) || !type" class="blue_Box" @click="handleDelete(row.id)">删除</span>
            <span v-if="checkAdmin() && type" class="blue_Box" @click="openHandleContract('audit', row)">合同审核</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 添加、编辑合同 -->
    <HandleContract ref="handleContractRef" />

    <RejectedList ref="rejectedList" />
  </div>
</template>

<script>
import {
  getCompanyContractListPage,
  delCompanyContract,
} from "@/api/organization";
import HandleContract from "@/views/organization/components/handleContract.vue";
import myPagination from "@/components/myPagination.vue";
import RejectedList from "./RejectedList";
export default {
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  components: {
    myPagination,
    HandleContract,
    RejectedList
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      companyId: "",
    };
  },
  methods: {
    // 删除
    handleDelete(id) {
      this.$confirm("确认要删除该合同吗?", "提示", {
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delCompanyContract({ id }).then((res) => {
            if (res.code === 0) {
              if (this.pageInfo.total >= this.pageInfo.limit) {
                let sum = this.pageInfo.total % this.pageInfo.limit;
                if (sum === 1) {
                  this.pageInfo.page =
                    Number(this.pageInfo.page) === 1
                      ? 1
                      : Number(this.pageInfo.page) - 1;
                }
              }
              this.refresh();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {});
    },
    // 查看附件
    lookFile(payload) {
      window.open(payload.fileurl);
    },
    // 刷新
    refresh() {
      this.getCompanyContractListPage({
        page: this.pageInfo.page,
        limit: this.pageInfo.limit,
      });
      this.$parent.refresh();
    },
    async getCompanyContractListPage(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      const res = await getCompanyContractListPage({
        ...payload,
        companyId: this.companyId,
      });
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    openHandleContract(status, payload) {
      this.$refs.handleContractRef.init(status, payload, this.companyId);
    },
    rejectedList(row) {
      if (row.hasReject === 0) {
        return
      }
      this.$refs.rejectedList.init(row)
    },
    // 初始化
    init(companyId) {
      this.companyId = companyId || "";
      this.getCompanyContractListPage({ page: 1, limit: 10 });
      this.dialogVisible = true;
    },
    // 关闭
    close() {
      this.dialogVisible = false;
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getCompanyContractListPage({
        page: payload,
        limit: this.pageInfo.limit,
      });
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getCompanyContractListPage({ page: 1, limit: payload });
    },
  },
};
</script>

<style lang="scss" scoped>
.contractAdmin {
  .title {
    margin: 0px 0 10px;
  }
  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
    &.is-disabled {
      color: #808080 !important;
      cursor: no-drop;
    }
  }

  .blue_Box:hover {
    color: #57a3f4;
  }
}
</style>
